module.exports = __webpack_public_path__ + "odstraneni-tetovaze_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_5_before.jpg
// module id = 962
// module chunks = 0